import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { ApiConfigs, ERROR_MESSAGES } from '../../config/apiConfig';

/**
 * ApiResponse interface for standardized API responses
 */
export interface ApiResponse<T = any> {
  status: string;
  message?: string;
  data: T;
}

/**
 * Interface for API Client methods
 */
export interface IApiClient {
  get<T = any>(endpoint: string, config?: AxiosRequestConfig): Promise<any>;
  post<T = any>(endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<any>;
  put<T = any>(endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<any>;
  delete<T = any>(endpoint: string, config?: AxiosRequestConfig): Promise<any>;
  patch<T = any>(endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<any>;
}

// Create axios instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: '',  // Empty to use proxy
  timeout: ApiConfigs.timeout,
  headers: {
    // "X-Requested-With": "XMLHttpRequest",
    // "Content-Type": "application/json", // Thay multipart/form-data nếu upload file

    // // "Content-Type": "multipart/form-data",
    // Accept: "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add token to header if available
      const token = localStorage.getItem('fastcms_token');
    if (token) {
      // config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('Request URL:', config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // Return data only if status is 'success'
    if (response.data && response.data.status === 'success') {
      return response.data;
    }
    return Promise.reject(new Error(response.data?.message || ERROR_MESSAGES.UNEXPECTED_ERROR));
  },
  (error: AxiosError) => {
    // Handle errors based on status code
    if (error.response) {
      const status = error.response.status;
      switch (status) {
        case 401:
          localStorage.removeItem('accessToken');
          break;
        case 403:
          break;
        case 404:
          break;
        case 500:
          break;
        default:
          break;
      }
      return Promise.reject(
        new Error((error.response.data as any)?.message || ERROR_MESSAGES.UNEXPECTED_ERROR)
      );
    } else if (error.request) {
      // Request was made but no response received
      console.error(ERROR_MESSAGES.NO_INTERNET);
      return Promise.reject(new Error(ERROR_MESSAGES.NO_INTERNET));
    } else {
      // Error setting up request
      console.error('Error:', error.message);
      return Promise.reject(error);
    }
  }
);

// API Client implementation using axios
const apiClient: IApiClient = {
  get: async <T = any>(endpoint: string, config?: AxiosRequestConfig) => 
    axiosInstance.get<T>(ApiConfigs.baseURL+endpoint, config),
  post: async <T = any>(endpoint: string, data?: any, config?: AxiosRequestConfig) =>
    axiosInstance.post<T>(ApiConfigs.baseURL+endpoint, data, config),
  put: async <T = any>(endpoint: string, data?: any, config?: AxiosRequestConfig) =>
    axiosInstance.put<T>(ApiConfigs.baseURL+endpoint, data, config),
  delete: async <T = any>(endpoint: string, config?: AxiosRequestConfig) =>
    axiosInstance.delete<T>(ApiConfigs.baseURL+endpoint, config),
  patch: async <T = any>(endpoint: string, data?: any, config?: AxiosRequestConfig) =>
    axiosInstance.patch<T>(ApiConfigs.baseURL+endpoint, data, config),
};

export default apiClient;
